export const FAKE_AUTHORS = [
  'Fyodor Dostoevsky',
  'Dante Alighieri',
  'Lev Tolstoy',
  'Victor Hugo',
  'William Shakespeare',
  'Johann Wolfgang von Goethe',
  'Miguel de Cervantes y Saavedra',
  'Italo Calvino',
  'Stendhal',
  'Charles Baudelaire',
  'Marcel Proust',
  'Giovanni Boccaccio',
  'Alexander Pushkin',
  'Jalaluddin Muhammad Rumi',
  'Franz Kafka',
  'Anton Chekhov',
  'Gabriel García Márquez',
  'Umberto Eco',
  'J.R.R. Tolkien',
  'William Faulkner',
  'Aesop',
  'Arthur Rimbaud',
  'Aristophanes',
  'Ivan Turgenev',
  'Sophocles',
  'Molière',
  'Charles Dickens',
  'Maxim Gorky',
  'George Orwell',
  'Edgar Allan Poe',
  'Publius Vergilius Maro',
  'Julio Cortázar',
  'Nazim Hikmet',
  'Oscar Wilde',
  'Jean de La Fontaine',
  'Rainer Maria Rilke',
  'Lord Byron',
  'Hans Christian Andersen',
  'Thomas Mann',
  'Alexandre Dumas',
  'James Joyce',
  'Louis-Ferdinand Céline',
  'Boris Pasternak',
  'Federico García Lorca',
  'Pablo Neruda',
  'Borges',
  'Beaumarchais',
  'Naguib Mahfouz',
  'Ursula K. Le Guin',
  'Nikolay Gogol',
  'Honoré de Balzac',
  'Ernest Hemingway',
  'Neil Gaiman',
  'Jean Racine',
  'Albert Camus',
  'Jean-Paul Sartre',
  'Chingiz Aitmatov',
  'John Steinbeck',
  'Milan Kundera',
  'Jules Verne',
  'Mark Twain',
  'Francois Rabelais',
  'Yasar Kemal',
  'George Bernard Shaw',
  'Arthur Conan Doyle',
  'Jane Austen',
  'Geoffrey Chaucer',
  'Antoine de Saint-Exupéry',
  'Erich Maria Remarque',
  'J.D. Salinger',
  'Virginia Woolf',
  'Louis Aragon',
  'Herman Melville',
  'Alphonse Daudet',
  'Mikhail Sholokhov',
  'Stefan Zweig',
  'José Saramago',
  'Bertolt Brecht',
  'Mario Vargas Llosa',
  'T.S. Eliot',
  'Guy de Maupassant',
  'John Keats',
  'Sabahattin Ali',
  'Ahmet Hamdi Tanpinar',
  'John Fante',
  'Henri-Frédéric Blanc',
  'Isaac Asimov',
  'Fitzgerald Scott',
  'J.M. Coetzee',
  'Kazuo Ishiguro',
  'Hermann Hesse',
  'Robert Louis Stevenson',
  'Salman Rushdie',
  'Mario Vargas Llosa',
  'Aldous Huxley',
  'Paul Valéry',
  'Thomas Pynchon',
  'H.P. Lovecraft',
  'Haruki Murakami',
  'Nikos Kazantzakis',
];

export const FAKE_EMAILS = FAKE_AUTHORS
  .map((name: string, index: number) => (
    name.replace(/([\s.]+)|([^A-Za-z]+)/gim, '-').toLowerCase() + index + '@yahoo.com'
  ));

export const FAKE_TASK_PREFIXES = 'axeurtyqwpsdfghjklzcvbnm'
  .split('')
  .map((symbol) => (new Array(5)).fill(symbol.toUpperCase()).join(''));

export const FAKE_COMPANIES = [
  'Apple',
  'Microsoft',
  'Samsung Electronics',
  'Alphabet',
  'AT&T', 'Amazon',
  'Verizon Communications',
  'China Mobile',
  'Walt Disney',
  'Facebook',
  'Alibaba',
  'Intel',
  'Softbank',
  'IBM',
  'Tencent Holdings',
  'Cisco Systems',
  'Oracle',
  'Deutsche Telekom',
  'Taiwan Semiconductor',
];
